import React from 'react'
import appStore from "../../src/assets/image/svg/appStroeIcon.svg";  // Replace with your image
import googlePlay from "../../src/assets/image/svg/googlePlayIcon.svg";

const Services = () => {
  return (
    <div id='downloadLink' className='py-5'>
        <div className="container text-center py-5">
            <h4 className='fs_63 fw-bold clr'>Your Services. Any Device.</h4>
            <p className='text-muted mb-0 mt-2'>Vasta is available on iPhone and Android.<br className='d-none d-md-block'></br> Book services anytime, anywhere, and manage your appointments with ease. Privacy and security are fully under your<br className='d-none d-md-block'></br> contro</p>
             <div className="d-flex gap-3 mt-5 justify-content-center">
             <a target='_blanck' href="https://apps.apple.com/us/app/vasta/id6752119785">  <img src={appStore} alt="App Store" height="50" /></a>
             <a target='_blanck' href="https://play.google.com/store/apps/details?id=com.vasta&hl=en"> <img src={googlePlay} alt="Google Play" height="50" /></a>
            </div>
        </div>
    </div>
  )
}

export default Services